/**
 * Paths for option chain.
 * - proxy: under our Next.js API (/api-next/option-chain/)
 * - upstream: external data API (server-side)
 */
export const optionChainRoutes = {
  optionChain: { proxy: 'option-chain', upstream: 'rest/v1/optionchain' },
} as const;
